import React, { useState, useEffect, useRef, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import FirstName from './FirstName'
import LastName from './LastName'
import DateOfBirth from './DateOfBirth'
import MasterNumber from './MasterNumber'
import NSHealthCardNumber from './NSHealthCardNumber'
import { listAddAction, listEditAction } from 'redux/actions';
import { validateNSHealthNumber } from '../../../../shared/helpers/validateNSHealthCardNumber'

var unidecode = require('unidecode')

const PersonalInformationView = ({ t, i18n, setIsError }) => {

  const dispatch = useDispatch();
  const history = useHistory()

  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [firstNameValid, setFirstNameValid] = useState('')
  const [lastNameValid, setLastNameValid] = useState('')
  const [dateOfBirthValid, setDateOfBirthValid] = useState('')
  const [masterNumberValid, setMasterNumberValid] = useState('')
  const [nsHealthCardNumberValid, setNSHealthCardNumberValid] = useState('')

  const [firstNameError, setFirstNameError] = useState('personal_info.first_name_error')
  const [lastNameError, setLastNameError] = useState('personal_info.last_name_error')
  const [dateOfBirthError, setDateOfBirthError] = useState('personal_info.date_of_birth_error')
  const [masterNumberError, setMasterNumberError] = useState('personal_info.master_number_error')
  const [nsHealthCardNumberError, setNSHealthCardNumberError] = useState('personal_info.ns_health_card_number_error')

  const dateOfBirthDayEl = useRef(null)
  const dateOfBirthMonthEl = useRef(null)
  const dateOfBirthYearEl = useRef(null)

  const personalInformation = useSelector((state) => state.app.personalInformation)
  const { dateOfBirth, firstName, lastName, masterNumber, nsHealthCardNumber, masterNumberDOB, editNSIdentifierNumber } = personalInformation;

  const { nsHealthCard, driverLicence, vehiclePermit, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  // const continueCancelProps = {
  //   prevText: t('personal_info.back'),
  //   prevURL: `/${i18n.language}${t('routes.listed_permits')}`,
  //   nextText: t('personal_info.next'),
  // }

  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get("isSummary") ?? false);
  }, [history]);

  useEffect(() => {
    try {
      if (!nsHealthCard && !driverLicence && !vehiclePermit && !registeredByName) {
        history.push(`/${i18n.language}${t('routes.address_type_change')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [driverLicence, history, i18n.language, nsHealthCard, registeredByName, setIsError, t, vehiclePermit])

  const onNext = () => {
    try {
      if (validateFields()) {
        if (editNSIdentifierNumber) {
          dispatch(
            listEditAction('personalInformation', {
              dateOfBirth, firstName, lastName, masterNumber, nsHealthCardNumber, masterNumberDOB
            })
          );
        } else {
          dispatch(listAddAction("personalInformation", {
            dateOfBirth, firstName, lastName, masterNumber, nsHealthCardNumber, masterNumberDOB
          }));
        }
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${t('routes.household_list')}`)
        }

      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {

      validateLastName(lastName)
      validateDateOfBirth(dateOfBirth)

      // if (driverLicence || registeredByName) {
      validateMasterNumber(masterNumber, nsHealthCard)
      // }
      if (firstName) {
        validateFirstName(firstName)
      }
      if (nsHealthCard) {
        validateNSHealthCardNumber(nsHealthCardNumber)
      }
      if (lastName === '') {
        setLastNameValid(false)
      }
      if (dateOfBirth === '') {
        setDateOfBirthValid(false)
      }
      // if ((driverLicence || registeredByName) && masterNumber === '') {
      //   setMasterNumberValid(false)
      // }
      if (nsHealthCard && nsHealthCardNumber === '') {
        setNSHealthCardNumberValid(false)
      }
      const testOptionalMasterCard = (nsHealthCard ? (masterNumberValid || masterNumberValid === '') : masterNumberValid)
      return (
        (firstNameValid === '' || firstNameValid === true) &&
        lastNameValid === true &&
        dateOfBirthValid === true &&
        testOptionalMasterCard &&
        // ((driverLicence || registeredByName) ? masterNumberValid === true : true) &&
        (nsHealthCard ? nsHealthCardNumberValid === true : true) &&
        lastName !== '' &&
        dateOfBirth !== '' &&
        // ((driverLicence || registeredByName) ? masterNumber !== '' : true) &&
        (nsHealthCard ? nsHealthCardNumber !== '' : true)
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFirstName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (regex.test(name)) {
        setFirstNameValid(true)
      } else {
        setFirstNameValid(false)
        setFirstNameError('personal_info.first_name_error_invalid')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateLastName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          setLastNameValid(true)
        } else {
          setLastNameValid(false)
          setLastNameError('personal_info.last_name_error_invalid')
        }
      } else {
        setLastNameValid(false)
        setLastNameError('personal_info.last_name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }


  const validateDateOfBirth = () => {
    try {
      let dayRegex = RegExp(/^\d{2}$/)
      let monthRegex = RegExp(/^\d{2}$/)
      let yearRegex = RegExp(/^\d{4}$/)
      if (
        dayRegex.test(dateOfBirthDayEl.current.value) &&
        monthRegex.test(dateOfBirthMonthEl.current.value) &&
        yearRegex.test(dateOfBirthYearEl.current.value)
      ) {
        let inputDate = `${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${dateOfBirthDayEl.current.value}`
        if (moment(inputDate).isValid()) {
          if (
            !moment(inputDate).isAfter(moment().format('YYYY-MM-DD'), 'day')
          ) {
            setDateOfBirthValid(true)
          } else {
            setDateOfBirthValid(false)
            setDateOfBirthError('personal_info.date_of_birth_error')
          }
        } else {
          setDateOfBirthValid(false)
          setDateOfBirthError('personal_info.date_of_birth_error')
        }
      } else {
        setDateOfBirthValid(false)
        setDateOfBirthError('personal_info.date_of_birth_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const getParsedMasterNumber = () => {
    let number = ''
    let parsedLastName = lastName.replace(/[^a-zA-Z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]/g, '')
    if (lastName && lastName[0].toLocaleLowerCase() === 'm' && lastName[1].toLocaleLowerCase() === 'c') {
      number = 'MAC'
      number = number + (parsedLastName[2] === undefined ? ' ' : parsedLastName[2])
      number = number + (parsedLastName[3] === undefined ? ' ' : parsedLastName[3])
    } else {
      for (let i = 0; i < 5; i++) {
        number = number + (parsedLastName[i] === undefined ? ' ' : parsedLastName[i])
      }
    }
    number = number + masterNumberDOB
    return number
  }

  const validateMasterNumber = (masterNumberElem) => {
    const isOptional = nsHealthCard;
    if (masterNumberElem.length === 0) {
      if (isOptional) {
        setMasterNumberValid('')
        return true;
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('personal_info.master_number_error_empty')
        return false
      }
    }

    if (lastName && lastName.length > 1 && masterNumberDOB && masterNumberDOB.length === 6) {
      const regex = RegExp(/^[a-zA-Z\s]{5}[0-9]{9}$/i)
      let fixedMasterNumber = masterNumberElem.substring(0, 11)
      if (
        regex.test(masterNumberElem) &&
        !isNaN(masterNumberElem.substring(11)) &&
        fixedMasterNumber &&
        fixedMasterNumber.toLocaleLowerCase() === unidecode(getParsedMasterNumber().toLocaleLowerCase())
      ) {
        setMasterNumberValid(true)
        return true
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('personal_info.master_number_error_invalid')
        return false
      }

    }
  }

  const validateNSHealthCardNumber = (number) => {
    try {
      const [isValid, errorStr] = validateNSHealthNumber(number);
      setNSHealthCardNumberValid(isValid);
      setNSHealthCardNumberError(errorStr);
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('personal_info.personal_information')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <FirstName
                validateFirstName={validateFirstName}
                firstNameError={firstNameError}
                firstNameValid={firstNameValid}
                setIsError={setIsError}
              />
              <LastName
                validateLastName={validateLastName}
                lastNameError={lastNameError}
                lastNameValid={lastNameValid}
                setIsError={setIsError}
              />
              <DateOfBirth
                validateDateOfBirth={validateDateOfBirth}
                validateMasterNumber={validateMasterNumber}
                dateOfBirthError={dateOfBirthError}
                dateOfBirthValid={dateOfBirthValid}
                dateOfBirthDayEl={dateOfBirthDayEl}
                dateOfBirthMonthEl={dateOfBirthMonthEl}
                dateOfBirthYearEl={dateOfBirthYearEl}
                setIsError={setIsError}
              />
              {/* NS Health Card */}
              {
                nsHealthCard ? <NSHealthCardNumber
                  validateNSHealthCardNumber={validateNSHealthCardNumber}
                  nsHealthCardNumberError={nsHealthCardNumberError}
                  nsHealthCardNumberValid={nsHealthCardNumberValid}
                  setIsError={setIsError}
                /> : null
              }
              {/* Drivers License Master Number */}
              {
                driverLicence || registeredByName ?
                  < MasterNumber
                    validateMasterNumber={validateMasterNumber}
                    masterNumberError={masterNumberError}
                    masterNumberValid={masterNumberValid}
                    setIsError={setIsError}
                    isOptional={nsHealthCard}
                  /> : null
              }
            </div>
          </div>
          <ContinueCancelButtons continueClick={onNext} errorText={''} />
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(PersonalInformationView)
